import { ErrorHandlerInterface, OrderData } from '../exports/Interfaces';
import BackendApiClient from './BackendApiClient';
import {
  ErrorResponse,
  ReservedHttpResponseCodes,
  SuccessfulResponse,
  ValidationErrorResponse,
} from '../exports/Types';

type ValidateOrderData = OrderData & {
  full_mode?: boolean;
};

class OrderValidationManager {
  public async validate(
    data: ValidateOrderData,
    errorHandlers?: ErrorHandlerInterface,
  ): Promise<
    | SuccessfulResponse<any, 200>
    | ErrorResponse<any, ReservedHttpResponseCodes.ErrorResponseModal>
    | ErrorResponse<any, ReservedHttpResponseCodes.ErrorResponseAlertWindow>
    | ValidationErrorResponse
  > {
    return await BackendApiClient.request(
      {
        method: 'POST',
        url: '/order-validations',
        data,
      },
      false,
      errorHandlers,
    );
  }
}

export default new OrderValidationManager();
